import * as styles from "./MeterLabel.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Meter as BaseMeter } from "@base-ui/react/meter";

import type { MeterLabelProps } from "./Meter.types";

export function MeterLabel({
  className,
  ...props
}: MeterLabelProps): JSX.Element {
  return (
    <BaseMeter.Label
      data-slot="meter-label"
      className={clsx(styles.label, className)}
      {...props}
    />
  );
}
